import type { CSSProperties, ReactNode } from 'react';

/** Shimmering placeholder block — the "loading" state for anything fetched. */
export function Skeleton({
  w = '100%',
  h = 16,
  r,
  className = '',
  style,
}: {
  w?: number | string;
  h?: number | string;
  r?: number | string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <span
      className={`skel ${className}`}
      style={{ width: w, height: h, borderRadius: r, ...style }}
      aria-hidden='true'
    />
  );
}

/** Paragraph-shaped skeleton with a ragged last line. */
export function SkeletonText({ lines = 4, gap = 10 }: { lines?: number; gap?: number }) {
  return (
    <span className='skel-stack' style={{ gap }} aria-hidden='true'>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} h={14} w={i === lines - 1 ? '62%' : i % 3 === 1 ? '92%' : '100%'} />
      ))}
    </span>
  );
}

/** Wraps skeleton content with an accessible live "loading" announcement. */
export function Loading({ label = 'माहिती लोड होत आहे…', children }: { label?: string; children: ReactNode }) {
  return (
    <div role='status' aria-live='polite' aria-busy='true'>
      <span className='sr-only'>{label}</span>
      {children}
    </div>
  );
}
